function validationReducer(state = {
  redirectNext:false,
    smscode:'',
    error:false,
    errornotvalid:false,
}, action) {
  switch (action.type) {
    case 'SET_REDIRECT':
      return {
        ...state,
        redirectNext: action.redirectNext,
      };
      case 'SET_SMSCODE':
        return {
          ...state,
          smscode: action.smscode,
        };
        case 'SET_SMS_ERROR':
        return {
          ...state,
          error: action.error,
        };

        case 'SET_SMS_ERROR_VALIDATOR':
          return {
            ...state,
            errornotvalid: action.error,
          };
        
    default:
      return state;
  }
}


export default validationReducer 





// WEBPACK FOOTER //
// src/reducers/validationReducer.js